import axios from 'axios';
// Axios base path
axios.defaults.baseURL = window.config.path;
// Axios default headers
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['X-CSRF-TOKEN'] = document.head.querySelector('meta[name="csrf-token"]').content;
// Axios jwt token by default
if (localStorage.getItem('token')) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
}


axios.interceptors.request.use(function (config) {

    if (config.params !== undefined) {

        if (config.params.filtroDatas !== undefined && config.params.filtroDatas.length > 0 && config.params.filtroDatas.length < 2) {
            swal.fire({
                title: "Atenção!",
                html: "A data inicial e final precisam ser preenchidas!",
                icon: "error",
            });

            return Promise.reject();
        }

        if (config.params.filtroDatasAt !== undefined && config.params.filtroDatasAt.length > 0 && config.params.filtroDatasAt.length < 2) {
            swal.fire({
                title: "Atenção!",
                html: "A data inicial e final precisam ser preenchidas!",
                icon: "error",
            });

            return Promise.reject();
        }

        if (config.params.filtroDatasDemanda !== undefined && config.params.filtroDatasDemanda.length > 0 && config.params.filtroDatasDemanda.length < 2) {
            swal.fire({
                title: "Atenção!",
                html: "A data inicial e final precisam ser preenchidas!",
                icon: "error",
            });

            return Promise.reject();
        }

    }

    return config;

});

// Axios error listener
axios.interceptors.response.use((response) => {
    return response;
}, function (error) {
    if (error.response.status === 401) {
        // If error 401 redirect to login
        window.location.href = window.config.path + '/auth/login';
        delete window.axios.defaults.headers.common.Authorization;
        localStorage.removeItem('token');
        localStorage.removeItem('token_suporte');
        throw new Error('Unauthorized');
    } else if (error.response.status === 406) {
        if (error.response.data.title) {
            swal.fire({ title: error.response.data.title, html: error.response.data.message, icon: 'error' });
            Ladda.stopAll();
            return error;
        }

        Ladda.stopAll();
        swal.fire({ title: 'Error', html: error.response.data.message, icon: 'error' });
        return error;
    }
    else if (error.response.status === 423) {
        Ladda.stopAll();
        let message = document.createElement('div');

        const data = error.response.data;
        message.innerHTML = data.message;

        swal.fire({ icon: 'warning', title: data.title, html: message });
        return Promise.reject(data.message);
    } else if (error.response.status === 413) {
        Ladda.stopAll();
        const message = error.response.data.message;
        swal.fire({ title: 'Arquivo muito grande', html: message, icon: 'warning' });
    }
    else if (error.response.data.message) {
        // If it is a notification error, display message
        Ladda.stopAll();
        let message = document.createElement('div');
        if (error.response.data.errors) {
            let content = '<ul class="text-left">';
            Object.keys(error.response.data.errors).forEach(function (element) {
                error.response.data.errors[element].forEach(function (item) {
                    content += '<li>' + item + '</li>';
                });
            });
            content += '</ul>';
            message.innerHTML = content;
        } else {
            message.innerHTML = error.response.data.message;
        }

        swal.fire({ title: 'Error', html: message, icon: 'error' });
        return Promise.reject(error.response.data.message);
    } else {
        // If it is an uncontrolled error, display http status

        Ladda.stopAll();
        swal.fire('Error ' + error.response.status, error.response.statusText, 'error');
        return Promise.reject(error);
    }
});

// Interceptor para capturar respostas 403 do middleware TermosDeUso
axios.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        // Verificar se é erro 403 do middleware de termos
        if (error.response && 
            error.response.status === 403 && 
            error.response.data.requires_terms) {
            
            swal.fire({
                title: 'Termos de Uso',
                text: 'Você precisa aceitar os Termos de Uso para continuar.',
                icon: 'warning',
                confirmButtonText: 'Ok',
                allowOutsideClick: false,
                allowEscapeKey: false,
            });
            
            // Redirecionar para página de termos
            if (window.location.pathname !== '/dashboard/termos-de-uso') {
                window.location.href = '/dashboard/termos-de-uso';
            }
            
            return Promise.reject(error);
        }
        
        // Para outros erros, continuar com o tratamento normal
        return Promise.reject(error);
    }
);

/**
 * Set global so you don't have to import it
 */
window.axios = axios;
